import API from '../../js/libs/API'
import download from './updateKml'
import localStorageUtils from './localStorageUtils'
var DOMParser = require('xmldom').DOMParser

export default {
  showDispatchKml,
  showSchualedKml,
  getDispatchCode,
  getSchualedCode,
  checkAndDownloadDispatch,
  checkAndDownloadSchedual,
  clearKml,
  checkSingleDispathchInLocal,
}
function showDispatchKml(kmlParser) {
  /*  input : geoXML3.parser 實例
        1. 在地圖上產生派遣區kml區域
    */
  if (
    localStorage.getItem('DispatchAreaArray') === null ||
    localStorage.getItem('DispatchAreaArray') === undefined
  ) {
    return
  }
  if (typeof localStorage.getItem('DispatchAreaArray') !== 'string') return

  const dispatchArray = localStorage.getItem('DispatchAreaArray').split(',')
  for (let i = 0; i < dispatchArray.length; i++) {
    kmlParser.parseKmlString(localStorage.getItem(`${dispatchArray[i]}`))
  }
}
function showSchualedKml(kmlParser) {
  /*  input : geoXML3.parser 實例
        1. 在地圖上產生排班區kml區域
    */
  if (
    localStorage.getItem('DispatchAreaArray') === null ||
    localStorage.getItem('DispatchAreaArray') === undefined
  )
    return
  const shiftAreaArray = localStorage.getItem('ShiftAreaArray').split(',')
  for (let i = 0; i < shiftAreaArray.length; i++) {
    kmlParser.parseKmlString(localStorage.getItem(`${shiftAreaArray[i]}`))
  }
}
function getDispatchCode() {
  /*  來做派遣區更新下載用
   */
  getDispatchCodeAPI().then((res) => {
    if (res.err === '無此車隊排班站資料') return
    checkAndDownloadDispatch(res)
  })
}

function clearKml() {
  localStorageUtils.localStorageClear()
}

function getSchualedCode() {
  /*  來做排班區更新下載用
   */
  getSchedualCodeAPI().then((res) => {
    if (res.err === '無此車隊排班站資料') return
    checkAndDownloadSchedual(res)
  })
}

function compareAndExclude(newList, oldList) {
  /* input newList: 資料庫最新資料
            oldList: 存在localstorage 資料
        output: 沒有重複kml array檔
        1. 利用舊資料比對，新資料 => 砍掉重複 => 舊的list, 新的list
    */
  if (oldList.length > newList.length) return false
  let newarray = []
  let oldarray = []

  /* 移除新增料與就資料重複的資料 */
  for (let i = 0; i < oldList.length; i++) {
    let result = newList
      .map(function (item) {
        return item.identification_code
      })
      .indexOf(oldList[i])
    if (result > -1) {
      delete newList[result]
      delete oldList[i]
    }
  }
  for (let i = 0; i < newList.length; i++) {
    if (newList[i] !== undefined) {
      newarray.push(newList[i].id)
    }
  }
  for (let i = 0; i < oldList.length; i++) {
    if (oldList[i] !== undefined) {
      oldarray.push(oldList[i].id)
    }
  }
  return { newarray, oldarray }
}

function checkAndDownloadDispatch(res) {
  let serverNewDispatchInfo = [] // 比對用資料
  let serverNewdispatchCode = [] // 存在localstorage
  let serverNewdispatchId = []
  let currentDispatchArray =
    localStorageUtils.localStorageGet('DispatchAreaArray')
  let oldDispatchArea = localStorageUtils.localStorageGet('DispatchAreaNumber')

  /* ===== 本地無資料下載  ===== */
  if (currentDispatchArray === null || oldDispatchArea === null) {
    // console.log('/* ===== 本地無資料下載  ===== */')
    download.getAllDispatchArea()
    return
  }
  /* ===== 檢查本地資料是否一致 ===== */
  // console.log(' /* ===== 檢查本地資料是否一致 ===== */')
  // let array = currentDispatchArray.split(',')
  // console.log(array)
  // for(let i = 0; i < array.length; i++){
  //   checkSingleDispathchInLocal(array[i])
  // }

  /* ===== 本地有資料，與遠端資料庫做比對 ===== */
  // 1. 本地有資料，取得資料庫最新資料
  // console.log('===== 本地有資料，與遠端資料庫做比對 =====')

  let newDispatchArea = res.result
  for (let i = 0; i < newDispatchArea.length; i++) {
    serverNewDispatchInfo.push({
      identification_code: newDispatchArea[i].identification_code,
      id: newDispatchArea[i].id,
    })
    serverNewdispatchCode.push(newDispatchArea[i].identification_code)
    serverNewdispatchId.push(`dispatch-${newDispatchArea[i].id}`)
  }
  let oldDispatchAreaArray = oldDispatchArea.split(',')
  let addDispatch = compareAndExclude(
    serverNewDispatchInfo,
    oldDispatchAreaArray,
  )
  if (!checkDispatchDownloadCondition(addDispatch)) {
    // DispatchAreaArray, DispatchAreaNumber
    localStorageUtils.localStorageSet(
      `DispatchAreaNumber`,
      serverNewdispatchCode.join(','),
    )
    localStorageUtils.localStorageSet(
      `DispatchAreaArray`,
      serverNewdispatchId.join(','),
    )
    return
  }
  // console.log('===== 本若以上的條件都沒有達到，則都會重新下載 =====')

  /* ===== 本若以上的條件都沒有達到，則都會重新下載 ===== */
  // 1. 刪除所有派遣區的kml資料
  deleteAllDispatchAreaArray(currentDispatchArray)
  // 2. 下載派遣區kml檔，並且存下來
  download.getAllDispatchArea()
}
function checkSingleDispathchInLocal(key) {
  // console.log('=====', key)
  // console.log(key,checkKmlStructuralIntegrity(localStorageUtils.localStorageGet(key)))
  if (localStorageUtils.localStorageGet(key) == null) {
    let id = key.replace('dispatch-', '')
    download.getSingleDispatchArea(id)
  } else if (
    !checkKmlStructuralIntegrity(localStorageUtils.localStorageGet(key))
  ) {
    // console.log('=====派遣區不完全', key)

    let id = key.replace('dispatch-', '')
    download.getSingleDispatchArea(id)
  }
}
function checkDispatchDownloadCondition(object) {
  // 比對完後，舊的Array => 刪除, 新的Array =>  新增

  if (object.oldarray.length !== 0 || object.newarray.length !== 0) {
    // add
    for (let i = 0; i < object.newarray.length; i++) {
      download.getSingleDispatchArea(object.newarray[i])
    }
    // 刪除本地資料
    for (let i = 0; i < object.oldarray.length; i++) {
      localStorageUtils.localStorageRemove(`dispatch-${object.oldarray[i]}`)
    }
    return false
  }
  if (object.oldarray.length === 0 && object.newarray.length === 0) return false

  return true
}
function deleteAllDispatchAreaArray(currentDispatchArray) {
  // console.log('All-Dispatch- 執行全部刪除')
  // 1. 刪除所有派遣區的kml資料
  if (currentDispatchArray === null) {
    // console.log('All-Dispatch- 執行全部下載')
    download.getAllDispatchArea()
    return
  } else {
    currentDispatchArray = currentDispatchArray.split(',')
  }
  for (let i = 0; i < currentDispatchArray.length; i++) {
    localStorageUtils.localStorageRemove(currentDispatchArray[i])
  }
  // 2. 最後移除派遣區所有標記
  localStorageUtils.localStorageRemove('DispatchAreaArray')
}

function checkAndDownloadSchedual(res) {
  let newSchedualedAreaLocalStorage
  let serverNewSchualedInfo = [] // 比對用資料
  let serverNewSchualedCode = [] // 存在localstorage
  let serverNewSchualedId = []
  let currentSchedualed = localStorageUtils.localStorageGet('ShiftAreaArray')
  let oldSchedualedArea =
    localStorageUtils.localStorageGet('SchedualAreaNumber')
  /* ===== 本地無資料下載  ===== */
  if (currentSchedualed === null || oldSchedualedArea === null) {
    download.getAllShiftArea()
    return
  }
  /* ===== 檢查本地資料是否一致 ===== */
  // console.log(' /* ===== 檢查本地資料是否一致 ===== */')
  let array = currentSchedualed.split(',')
  for (let i = 0; i < array.length; i++) {
    checkSingleScheduleInLocal(array[i])
  }
  /* ===== 本地有資料，與遠端資料庫做比對 ===== */
  // 1. 本地有資料，取得資料庫最新資料
  let newSchedualedArea = res.result
  for (let i = 0; i < newSchedualedArea.length; i++) {
    serverNewSchualedInfo.push({
      identification_code: newSchedualedArea[i].identification_code,
      id: newSchedualedArea[i].id,
    })
    serverNewSchualedId.push(`schedualed-${newSchedualedArea[i].id}`)
    serverNewSchualedCode.push(newSchedualedArea[i].identification_code)
  }
  // 3. 本地有資料，取得本地資料轉為陣列
  let oldSchedualedAreaArray = oldSchedualedArea.split(',')

  // 4. 有舊資料 => 與新資料比對
  let addSchedualed = compareAndExclude(
    serverNewSchualedInfo,
    oldSchedualedAreaArray,
  )
  if (!checkSchedualedDownloadCondition(addSchedualed)) {
    // 更新ShiftAreaArray, SchedualAreaNumber
    localStorageUtils.localStorageSet(
      `SchedualAreaNumber`,
      serverNewSchualedCode.join(','),
    )
    localStorageUtils.localStorageSet(
      `ShiftAreaArray`,
      serverNewSchualedId.join(','),
    )
    return
  }

  /* ===== 本若以上的條件都沒有達到，則都會重新下載 ===== */
  // 1. 刪除所有排班站的kml資料
  let currentSchedualedArray = []
  deleteAllScheduleAreaArray(currentSchedualed)
  // 2. 下載派遣區kml檔，並且存下來
  download.getAllShiftArea()
}

function deleteAllScheduleAreaArray(currentDispatchArray) {
  // console.log('All-Schedule- 執行全部刪除')
  let currentSchedualedArray = []
  // 1. 刪除所有派遣區的kml資料
  if (currentDispatchArray === null) {
    // console.log('All-Schedule- 執行全部下載')
    download.getAllShiftArea()
    return
  } else {
    currentSchedualedArray = currentDispatchArray.split(',')
  }
  for (let i = 0; i < currentSchedualedArray.length; i++) {
    localStorageUtils.localStorageRemove(currentSchedualedArray[i])
  }
  // 2. 最後移除派遣區所有標記
  localStorageUtils.localStorageRemove('DispatchAreaArray')
}
function checkSingleScheduleInLocal(key) {
  if (localStorageUtils.localStorageGet(key) == null) {
    let id = key.replace('schedualed-', '')
    download.getSingleSchedualedArea(id)
  }
}
function checkSchedualedDownloadCondition(object) {
  // 比對完後，舊的Array => 刪除, 新的Array =>  新增

  if (object.oldarray.length !== 0 || object.newarray.length !== 0) {
    // add
    for (let i = 0; i < object.newarray.length; i++) {
      download.getSingleSchedualedArea(object.newarray[i])
    }
    // 刪除本地資料
    for (let i = 0; i < object.oldarray.length; i++) {
      localStorageUtils.localStorageRemove(`schedualed-${object.oldarray[i]}`)
    }
    return false
  }
  if (object.oldarray.length === 0 && object.newarray.length === 0) return false
  return true
}
async function getDispatchCodeAPI() {
  return await API.get(`/dispatch-area/identificaiton-code`)
}
async function getSchedualCodeAPI() {
  return await API.get(`/shift-area/identificaiton-code`)
}
function checkSingleSchedualInLocal(key) {
  if (localStorageUtils.localStorageGet(key) == null) {
    // console.log(key)
    let id = key.replace('schedualed-', '')
    download.getSingleSchedualedArea(id)
  }
}

function checkKmlStructuralIntegrity(xmlString) {
  if (xmlString === null) return null
  try {
    let parser = new DOMParser()
    let xmlDoc = parser.parseFromString(xmlString, 'text/xml')
    if (xmlDoc.getElementsByTagName('coordinates')[0] === undefined) {
      // console.log(xmlString)
      return false
    }
    // console.log('====', xmlDoc.getElementsByTagName("coordinates")[0].childNodes[0].nodeValue)
    // console.log('====', xmlDoc.getElementsByTagName("coordinates"))

    if (
      xmlDoc.getElementsByTagName('coordinates')[0].childNodes[0] === undefined
    ) {
      console.log('xmlString', xmlString)
      return false
    }
    return true
  } catch (err) {
    console.log(err)
    return false
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/tool/kmlTool.js